import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, intervalMs: { type: Number, default: 1500 } }

  connect() {
    this.timer = null

    if (this.element.querySelector('[aria-busy="true"]')) {
      this.timer = window.setInterval(() => this.refresh(), this.intervalMsValue)
    }
  }

  disconnect() {
    this.stopPolling()
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })

      if (response.status === 204 || !response.ok) return

      const contentType = response.headers.get("Content-Type") || ""
      if (!contentType.includes("turbo-stream")) return

      window.Turbo.renderStreamMessage(await response.text())
      this.stopPolling()
    } catch (_error) {
      // The ActionCable broadcast remains the primary notification path.
    }
  }

  stopPolling() {
    if (this.timer) window.clearInterval(this.timer)
    this.timer = null
  }
}
